import { TranslateModule } from '@ngx-translate/core'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ShiftComponent } from './shift.component';
import { ListStatusModule } from 'src/app/share/list-status/list-status.module';
import { DurationModule } from 'src/app/share/duration/duration.module';
import { ChatDatetimeModule } from 'src/app/pipe/chat-datetime/chat-datetime.module';
import { AvatarModule } from 'src/app/share/avatar/avatar.module';
import { PhonePipeModule } from 'src/app/pipe/phone/phone-pipe.module';

@NgModule({
	declarations: [ShiftComponent],
	exports: [ShiftComponent],
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		FlexLayoutModule,
		ListStatusModule,
		DurationModule,
		ChatDatetimeModule,
		AvatarModule,
		PhonePipeModule,
		TranslateModule
	],
})
export class ShiftModule {}
